import React, { useState } from 'react';
import './RedCactus.scss';
import { IS_RED_CACTUS_BUBBLE_ENABLED } from "../../constants";

const RedCactus: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  if (!IS_RED_CACTUS_BUBBLE_ENABLED) return null;
  const toggleBubble = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Floating Button */}
      <button className="floating-button" onClick={toggleBubble}>
        <img src={require("../../assets/images/icon.png")} alt="RedCactus Icon" />
      </button>

      {/* Floating iFrame Bubble */}
      {isOpen && (
        <div className="iframe-bubble">
          <iframe src="https://eu.bubble365.app" title="RedCactus Bubble" />
        </div>
      )}
    </>
  );
};

export default RedCactus;
